// 打印机配置 Vuex 模块

const state = {
  defaultPrinterName: '',
  paperSize: 'A4',
  autoPrint: false,
  copies: 1,
}

const mutations = {
  SET_DEFAULT_PRINTER_NAME(state, name) {
    state.defaultPrinterName = name
  },
  SET_PAPER_SIZE(state, size) {
    state.paperSize = size
  },
  SET_AUTO_PRINT(state, flag) {
    state.autoPrint = flag
  },
  SET_COPIES(state, count) {
    state.copies = Math.max(1, Math.min(10, count || 1))
  },
  LOAD_SETTINGS(state, settings) {
    if (settings) {
      state.defaultPrinterName = settings.defaultPrinterName || ''
      state.paperSize = settings.paperSize || 'A4'
      state.autoPrint = settings.autoPrint || false
      state.copies = settings.copies || 1
    }
  },
}

const actions = {
  saveSettings({ commit, state }) {
    const settings = {
      defaultPrinterName: state.defaultPrinterName,
      paperSize: state.paperSize,
      autoPrint: state.autoPrint,
      copies: state.copies,
    }
    localStorage.setItem('printer_settings', JSON.stringify(settings))
    return Promise.resolve()
  },

  loadSettings({ commit }) {
    try {
      const json = localStorage.getItem('printer_settings')
      if (json) {
        const settings = JSON.parse(json)
        commit('LOAD_SETTINGS', settings)
      }
    } catch (e) {
      console.error('加载打印机设置失败:', e)
    }
    return Promise.resolve()
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
